import { mutationRemove, type RemoveHookResponse } from '../../hooks'
import { useTantalimMutation } from '../../mutation'
import { useInterviewQuestionCache } from './cache'
import {
  type InterviewQuestionRemoveInput,
  type InterviewQuestionRemoveSuccess,
  Logger,
  toResponseError,
} from '@terros/common'

const logger = new Logger('useRemoveInterviewQuestion')

export function useRemoveInterviewQuestion(): RemoveHookResponse<InterviewQuestionRemoveInput> {
  logger.verbose('calling useRemoveInterviewQuestion')
  const cache = useInterviewQuestionCache()
  const mutation = useTantalimMutation<InterviewQuestionRemoveInput, InterviewQuestionRemoveSuccess>({
    url: '/interview/question/remove',
  })

  async function remove(input: InterviewQuestionRemoveInput): Promise<void> {
    try {
      await mutation.mutateAsync(input)
      cache.removeItem(input.questionId)
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
